module.exports = __webpack_public_path__ + "img/171824-10.70fc92fe.png";